// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import { createDemoRequest } from "../../../services/accIqService";
import {
  SUBMIT_DEMO_REQUEST,
  submitDemoSuccess,
  submitDemoFailure
} from "../actions/demoRequestActions";
import { fetchClosureAgent } from "../../../services/accIqService";

// Saga function
function* handleDemoRequestSubmission(action) {
  try {
    const response = yield call(
        createDemoRequest, 
        action.payload.requestType,
        action.payload.roundOfDemo,
        action.payload.sellerAccountName,
        action.payload.buyerAccountName,
        action.payload.sellerIndustry,
        action.payload.buyerIndustry,
        action.payload.demoDateTime,
        action.payload.question,
        action.payload.salesPersonNameAndDesignation,
        action.payload.icpNameAndDesignation,
        action.payload.productListCsv,
        action.payload.csvData,
        // action.payload.demoStartTime,
        // action.payload.demoCompletionTime,
        // action.payload.email,
        // action.payload.name,
        // action.payload.readyState,
        // action.payload.detailsSentToRequestor,
        // action.payload.demoFeedback,
        // action.payload.qcedByProduct,
        // action.payload.qcedByResearch,
        // action.payload.deliveredToRequestor,
    );
    yield put(submitDemoSuccess(response || "Demo request not submitted."));
  } catch (error) {
    yield put(submitDemoFailure(error.error));
  }
}

export function* watchDemoRequestSubmission() {
  yield takeLatest(SUBMIT_DEMO_REQUEST, handleDemoRequestSubmission);
}